<template>
  <section>
    <Feature :title="$t('RM_TYPE_MAINTAIN')" :iconClass="'fa-database'">
      <FormRow :fieldNameArr="['', '']">
        <Button type="primary" @click="create" slot="a">{{ $t('ADD') }}</Button>
        <Button type="primary" @click="download" slot="b">{{ $t('DOWNLOAD') }}</Button>
      </FormRow>
      <TablePage :tableWidth="windowWidth" :columnsList="columnsList" :resultList="dataList" v-if="isData"></TablePage>
    </Feature>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" v-model="modal" :title="actionWord"
      @on-ok="confirm">
      <FormRow :fieldNameArr="[$t('CATEGORY'), $t('RM_TYPE'), $t('REMARK')]">
        <Select style="width: 200px;" v-model="rmType.rmCategory" :placeholder="$t('CHOOSE_ROLE')" slot="a">
          <Option v-for="(item, index) in rmCategoryList" :value="item.code" :key="index">
            {{ item.name }}
          </Option>
        </Select>
        <Input v-model="rmType.type" :maxlength="20" slot="b" />
        <Input v-model="rmType.remark" slot="c" />
      </FormRow>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { Translate, ExceptionHandling } from "@/util/common"

export default {
  name: "RmTypeMaintain",
  created() {
    search(this)
  },
  data() {
    return {
      isCreated: true,
      enabled: "YES",
      modal: false,
      rmCategoryList: [{
        code: 'RESIN',
        name: 'Resin'
      }, {
        code: 'STEEL',
        name: 'Steel'
      }, {
        code: 'CCL',
        name: 'CCL'
      }],
      rmType: {
        type: "",
        rmCategory: "",
        remark: ""
      },
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("COMMON_BUTTON_operation")
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "action",
          width: 120,
          align: "center",
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-create",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.edit(params.row)
                },
              },
            })
          },
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CATEGORY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "rmCategoryName",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RM_TYPE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "type",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REMARK')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: "remark",
          sortable: true
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENABLED')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 120,
          sortable: true,
          align: "center",
          render: (h, params) => {
            return params.row.enabled
              ? h("Icon", {
                props: {
                  type: "md-checkmark-circle",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    params.row.enabled = !params.row.enabled
                    this.setEnalbe(params.row)
                  },
                },
              })
              : h("Icon", {
                props: {
                  type: "md-close-circle",
                  size: 28,
                },
                class: "text-delta-red",
                on: {
                  click: () => {
                    params.row.enabled = !params.row.enabled
                    this.setEnalbe(params.row)
                  },
                },
              })
          },
        }
      ],
      dataList: []
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    create() {
      this.isCreated = true
      this.modal = true
      this.rmType = {
        type: "",
        rmCategory: "RESIN",
        remark: ""
      },
        this.enabled = "YES"
    },
    edit(row) {
      this.isCreated = false
      this.modal = true
      this.rmType = row
    },
    confirm() {
      const vueInstance = this
      if (vueInstance.valid()) {
        createOrUpdate(vueInstance, vueInstance.rmType)
      }
    },
    download() {
      this.$getDownloadExcel(this, "rmType", "?sort=rmCategory&sort=type")
    },
    valid() {
      let errorMessage = ""

      if (!this.rmType.type) {
        errorMessage = errorMessage + this.$t('PLEASE_KEY_IN') + this.$t('RM_TYPE') + " <br>"
      }
      if (errorMessage) {
        AlertInfo(this, errorMessage).then(() => {
        })
      }
      return errorMessage == ""
    },
    setEnalbe(data) {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$quotationHttp
        .post("/rmType/enable", JSON.stringify(data))
        .then((response) => {
          search(vueInstance)
        })
        .catch((error) => {
          vueInstance.toggleLoading(false)
          let text = ExceptionHandling(error.response)
          vueInstance.$Swal.fire({
            icon: "error",
            title: Translate("COMMON_MESSAGE_ERROR"),
            html: text,
          })
        })
    }
  },
  computed: {
    actionWord() {
      return this.isCreated ? this.$t('ADD') : this.$t('UPDATE')
    },
    modalSize() {
      return this.getModalSize()
    },
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function search(vueInstance) {
  vueInstance.toggleLoading(true)
  vueInstance.$quotationHttp
    .get("/rmType/find")
    .then((response) => {
      vueInstance.toggleLoading(false)
      if (response.data._embedded) {
        vueInstance.dataList = response.data._embedded.rmTypeResourceList
      }
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}

function createOrUpdate(vueInstance, data) {
  let action = "create"
  vueInstance.toggleLoading(true)
  if (!vueInstance.isCreated) {
    action = "update"
  }
  vueInstance.$quotationHttp
    .post("/rmType/" + action, JSON.stringify(data))
    .then((response) => {
      search(vueInstance)
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      let text = ExceptionHandling(error.response)
      vueInstance.$Swal.fire({
        icon: "error",
        title: Translate("COMMON_MESSAGE_ERROR"),
        html: text,
      })
    })
}
</script>

<style scoped></style>
